import client from "lib/apolloClient/client";
import { getCurriculumProgramByProgramIdQuery } from "./CurriculumOptionsQuery";
import _ from "lodash";

export const getCurriculumProgramDataFromProgramId = async ({ id }) => {
  const data = await client.query({
    query: getCurriculumProgramByProgramIdQuery,
    variables: {
      id,
    },
  });
  return _.get(data, "data.planner.curriculumProgramDataByPlatformId", {});
};
